import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethodsHotelNumber/FilterAttributeMethodsHotelNumber';
import dataAttributesBeachType from './dataAttributesBeachType';
import { IBeachType } from '.';

const filterAttributesMethodsBeachType = new FilterAttributeMethods<IBeachType>(dataAttributesBeachType, 'beachType').setFilterName('Тип пляжа');

export default filterAttributesMethodsBeachType;